import { useState } from 'react';
import { actualizarPreciosMasivo } from '../services/productoService';

/**
 * Hook para gestionar la actualización masiva de precios
 * @returns {Object} { updating, error, actualizarPrecios }
 */
export const usePreciosMasivo = () => {
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);

  const actualizarPrecios = async (ids, precios) => {
    setUpdating(true);
    setError(null);

    try {
      await actualizarPreciosMasivo(ids, precios);
      return { success: true };
    } catch (err) {
      const errorMessage = err.message || 'Error al actualizar los precios';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setUpdating(false);
    }
  };

  return {
    updating,
    error,
    actualizarPrecios,
  };
};

